export interface UnorderedDiff {
  addIDs: string[];
  removeIDs: string[];
}

/**
 * Membership changes between two sets of foreign-key ids, or null when the
 * membership is the same.
 *
 * Order is ignored on purpose. These edges are written with `addXxxIDs` and
 * `removeXxxIDs`, which carry no position, so a reordered array of the same ids
 * describes exactly the same server state. Treating a reorder as a change would
 * emit a write that the server cannot distinguish from a no-op.
 *
 * Duplicates collapse for the same reason: an id is either linked or it is not.
 * See T1-6071.
 */
export function diffUnordered(
  previous: string[],
  next: string[]
): UnorderedDiff | null {
  const before = new Set(previous);
  const after = new Set(next);

  const addIDs = Array.from(after).filter((id) => !before.has(id));
  const removeIDs = Array.from(before).filter((id) => !after.has(id));

  if (addIDs.length === 0 && removeIDs.length === 0) {
    return null;
  }

  return { addIDs, removeIDs };
}
